<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="基本信息">
        <el-descriptions :label-style="{width: '80px'}" :column="1" size="mini" border>
          <el-descriptions-item label="节点ID">
            <el-input :value="id" :disabled="true"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="节点名称">
            <el-input v-model="text"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="紧急程度">
            <el-switch @change="onInput"
                       v-model="form.urgency"
                       active-color="#13ce66"
                       inactive-color="#ff4949">
            </el-switch>
          </el-descriptions-item>
          <el-descriptions-item label="提醒方式">
            <el-checkbox-group v-model="form.remind_value">
              <el-checkbox @change="onInput" v-for="(item,index) in remind_list" :label="item.name" :key="index">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="审批意见">
            <el-switch @change="onInput"
                       v-model="form.suggestion"
                       active-color="#13ce66"
                       inactive-color="#ff4949">
            </el-switch>
          </el-descriptions-item>
          <el-descriptions-item label="附件上传">
            <el-switch @change="onInput"
                       v-model="form.enclosure"
                       active-color="#13ce66"
                       inactive-color="#ff4949">
            </el-switch>
          </el-descriptions-item>
          <el-descriptions-item label="提交/暂存">
            <el-checkbox @change="onInput" v-model="form.is_submit">提交</el-checkbox>
            <el-checkbox @change="onInput" v-model="form.is_staging">暂存</el-checkbox>
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
      <el-tab-pane label="表单">
        <BpmnForm v-model="form.form_fields" :default_read="true" :default_write="true" @success="onInput" />
      </el-tab-pane>
      <el-tab-pane label="监听">
        <BpmnMonitor v-model="form.monitor" @success="onInput" />
      </el-tab-pane>
      <el-tab-pane label="扩展">
        <BpmnExtend v-model="form.extend" @success="onInput" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import BpmnMonitor from "./components/BpmnMonitor";
import BpmnExtend from "./components/BpmnExtend";
import FlowCommon from "../lib/FlowCommon";
import BpmnForm from "./components/BpmnForm";
export default {
  name: 'StartProperty',
  components: {BpmnForm, BpmnExtend, BpmnMonitor},
  props: {
    nodeData: Object,
    lf: Object || String,
  },
  mounted() {
    this.onInit()
  },
  data() {
    return {
      id:"",
      text:"",
      form: FlowCommon.getNodeDefaultConfig('start').properties,
      remind_list:[
        {name: "及时消息",value:"1"},
        {name: "电子邮件",value:"2"},
        {name: "手机短信",value:"3"},
        {name: "企业微信",value:"4"},
      ]
    }
  },
  watch:{
    text(n){
      const nodeData = this.$props.nodeData
      this.$props.lf.updateText(nodeData.id, n);
    }
  },
  methods: {
    onInit(){
      const { properties,text,id } = this.$props.nodeData
      this.id=id;
      this.text=(text||{}).value||"";
      if (properties) {
        this.$data.form = Object.assign({}, this.$data.form, properties)
      }
    },
    onInput(){
      const that = this;
      const nodeData = that.$props.nodeData
      nodeData.properties = that.$data.form
      that.$props.lf.setProperties(nodeData.id, that.$data.form);
    },
    onSubmit() {

    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/PropertySetting/StartProperty.vue